import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FatorEcg } from 'src/app/model/tranche.model';

@Component({
    selector: 'app-modal-confirma-fator-ecg',
    templateUrl: './modal-confirma-fator-ecg.html',
    styleUrls: ['./modal-confirma-fator-ecg.scss'],
    standalone: false
})

//Modal de fatores de ecg que abre a partir de outro modal 

export class ModalConfirmaFatorEcgComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void { }

  public salvar(): void {
    this.activeModal.close({botao: 'sim'});
  }

  public cancelar(): void {
    this.activeModal.close({botao: 'cancelar'});
  }

  public fechar(): void {
    this.activeModal.close({botao: 'fechar'});
  }
}
